<template>
  <li class="m-nav__item m-topbar__user-profile m-topbar__user-profile--img  m-dropdown m-dropdown--medium m-dropdown--arrow m-dropdown--header-bg-fill m-dropdown--align-right m-dropdown--mobile-full-width m-dropdown--skin-light" data-dropdown-toggle="click">
    <a id="user-dropdown" href="#" class="m-nav__link m-dropdown__toggle">
      <span class="m-nav__link-icon">
        <span class="m-nav__link-icon-wrapper">
          <i class="flaticon-user-ok notification-i"></i>
        </span>
			</span>
    </a>
    <div class="m-dropdown__wrapper">
      <span class="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust arrow-user"></span>
      <div class="m-dropdown__inner">
        <div class="m-dropdown__header m--align-center" style="background: url(assets/app/media/img/misc/user_profile_bg.jpg); background-size: cover;">
          <div class="m-card-user m-card-user--skin-dark">
            <div class="m-card-user__pic">
              <img src="/media/img/logo_m.png" class="m--img-rounded m--marginless" alt=""/>
            </div>
            <div class="m-card-user__details">
              <span class="m-card-user__name m--font-weight-500 font-small-user">
                {{ fullName }}
              </span>
              <small class="m-card-user__name m--font-weight-200 font-small-data" id="nameCompanyProfile">
                {{ company }}
              </small>
              <small class="m-card-user__name m--font-weight-200 font-small-data" id="nameProfileProfile">
                {{ profile }}
              </small>
            </div>
          </div>
        </div>
        <div class="m-dropdown__body">
          <div class="m-dropdown__content">
            <ul class="m-nav m-nav--skin-light">
              <li class="m-nav__section m--hide">
                <span class="m-nav__section-text">
                  {{ 'section' | capitalize }}
                </span>
              </li>
              <li class="m-nav__item">
                <router-link id="btn-user-dropdown" :to="`/profile/${this.$store.state.authentication.user_data.id}`" class="m-nav__link">
                  <i class="m-nav__link-icon flaticon-profile-1"></i>
                  <span class="m-nav__link-title">
                    <span class="m-nav__link-wrap">
                      <span class="m-nav__link-text">
                        {{ 'my_profile' | capitalize }}
                      </span>
                    </span>
                  </span>
                </router-link>
              </li>
              <li class="m-nav__item">
						    <router-link to="/select-property" class="m-nav__link">
								  <i class="m-nav__link-icon flaticon-logout"></i>
									<span class="m-nav__link-text">
										{{ 'change_profile' | capitalize }}
									</span>
								</router-link>
							</li>
              <li class="m-nav__separator m-nav__separator--fit"></li>
              <li class="m-nav__item">
                <router-link :to="'/faq'" class="m-nav__link">
                  <i class="m-nav__link-icon flaticon-info"></i>
                  <span class="m-nav__link-text">
                    {{ 'faq' | capitalize }}
                  </span>
                </router-link>
              </li>
              <li class="m-nav__item">
                <router-link :to="'/contact'" class="m-nav__link">
                  <i class="m-nav__link-icon flaticon-lifebuoy"></i>
                  <span class="m-nav__link-text">
                    {{ 'contact' | capitalize }}
                  </span>
                </router-link>
              </li>
              <li class="m-nav__separator m-nav__separator--fit"></li>
              <li class="m-nav__item">
							  <a @click.prevent="logout()" class="btn m-btn--pill    btn-secondary m-btn m-btn--custom m-btn--label-brand m-btn--bolder">
								  {{ 'logout' | capitalize }}
								</a>
							</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    user: { required: true }
  },
  data () {
    return {
      company: '',
      profile: ''
    }
  },
  computed: {
    ...mapGetters({ shard: 'getUserShard' }),
    fullName () {
      return `${this.user.first_name} ${this.user.last_name}`
    }
  },
  methods: {
    ...mapActions(['postDataUserProfile']),
    logout () {
      this.$store.dispatch('postLogout')
      this.$store.state.authentication.logged_in = false
      localStorage.removeItem('logged_in')
      localStorage.removeItem('user_email')
      localStorage.removeItem('user_data')
      localStorage.removeItem('user_shard')
      localStorage.removeItem('sections')
      this.$store.commit('addSections', [])
      this.$router.push({ name: 'login' })
    }
  },
  mounted () {
    this.postDataUserProfile(this.shard)
      .then((res) => {
        this.company = res.data.company
        this.profile = res.data.profile
      })
      .catch((err) => {
        console.log(err)
      })
  }
}
</script>

<style>
.font-small-user {
  margin-top:7px;
  font-size: 1.2em !important;
}

.font-small-data {
  margin-top:7px;
  font-size: 1.0em !important;
}
</style>



// WEBPACK FOOTER //
// Profile.vue